import { Routes, Route } from 'react-router-dom';
import HeroSection from './components/HeroSection';
import Footer from './components/Footer';
import AsystoPage from './components/AsystoPage';
import Navbar from './components/Navbar4';
import ScrollToTop from './components/ScrollToTop'; // dopasuj ścieżkę

function App() {
  return (
    <div className="font-sans bg-gray-50 min-h-screen flex flex-col">
      <main className="flex-grow">
        <Navbar />
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <HeroSection />
              </>
            }
          />
          <Route path="/rezerwacja" element={<AsystoPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
